import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { FeatureFlagService } from '../feature-flag.service';

@Directive({
    selector: '[myRemoveIfFeatureOn]'
})
export class MyRemoveIfFeatureOnDirective implements OnInit {
    @Input('myRemoveIfFeatureOn') featureName: string;

    constructor(private el: ElementRef,
        private featureFlagService: FeatureFlagService) {
    }

    ngOnInit() {
        if (this.featureFlagService.featureOn(this.featureName)) {
            this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
        }
    }
}